import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { CouponHistoryService } from 'app/services/campaign/coupon-history.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { moment } from 'fullcalendar';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-coupon-history',
  templateUrl: './coupon-history.component.html',
  styleUrls: ['./coupon-history.component.css']
})
export class CouponHistoryComponent implements OnInit, OnDestroy {

  @ViewChild('table') table: KontableComponent;

  paginationType = KontableComponent.ServerPagination;
  dateFilter = KontableComponent.DateFilter;

  couponList: any[] = [];
  customerId: string;
  clientCustomerId: string;

  field: {
    coupon_code?: string,
    coupon_type?: string,
    barcode?: string,
    card_no?: string,
  } = {};

  couponReservedMap: { [key: number]: string } = {};
  couponPrintedStateMap: { [key: number]: string } = {};
  operationTypeMap: { [key: string]: string } = {};

  private langSub: Subscription;

  constructor(
    private couponHistoryService: CouponHistoryService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService
  ) {
    couponHistoryService.couponId = activatedRoute.snapshot.params['couponId'];
  }

  ngOnInit() {
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.clientCustomerId = this.activatedRoute.snapshot.params['customer_id'];

    // inizializzo le traduzioni e poi carico i dati
    this.setTranslations(() => this.loadCouponData());

    // aggiorno le traduzioni al cambio lingua
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.setTranslations();
    });
  }

  ngOnDestroy() {
    if (this.langSub) this.langSub.unsubscribe();
  }

  private setTranslations(callback?: () => void) {
    this.translate.get([
      'common.not_booked',
      'common.booked',
      'common.not_printed',
      'common.printed',
      'common.print',
      'common.reserve',
      'common.use',
      'common.undoReserve',
      'common.undoUse',
      'common.generation'
    ]).subscribe(translations => {

      this.couponReservedMap = {
        0: translations['common.not_booked'],
        1: translations['common.booked']
      };

      this.couponPrintedStateMap = {
        0: translations['common.not_printed'],
        1: translations['common.printed']
      };

      this.operationTypeMap = {
        P: translations['common.print'],
        R: translations['common.reserve'],
        U: translations['common.use'],
        UR: translations['common.undoReserve'],
        UU: translations['common.undoUse'],
        GE: translations['common.generation']
      };

      if (callback) callback();
    });
  }

  private loadCouponData() {
    this.couponHistoryService.getCouponAuditLog().subscribe(res => {
      this.couponList = res.map(coupon => {
        this.convertTime(coupon);
        return coupon;
      });

      if (res.length) {
        this.field = {
          coupon_code: res[0].coupon_code || null,
          coupon_type: res[0].coupon_type || null,
          barcode: res[0].barcode || null,
          card_no: res[0].card_no || null
        };
      }
    });
  }

  private convertTime(coupon: any) {
    coupon.ts_ins = moment(coupon.ts_ins).format('YYYY-MM-DD HH:mm:ss');
  }

  goBack() {
    this.couponList = null;
    this.router.navigate([
      `customers-details/${this.customerId}/${this.clientCustomerId}`,
      { previousTab: this.activatedRoute.snapshot.paramMap.get('previousTab') }
    ]);
  }

  getCouponReserved(value: number | null): string {
    return value != null ? this.couponReservedMap[value] || '' : '';
  }

  getCouponPrintState(value: number | null): string {
    return value != null ? this.couponPrintedStateMap[value] || '' : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/coupon-manager/coupon-history/coupon-history.component.ts